import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTopDiv({ scrollRef }) {
  const { pathname } = useLocation()

  useEffect(() => {
    if (scrollRef?.current) {
      scrollRef.current.scrollTop = 0
    }
  }, [pathname])

  return null
}
